import { render, staticRenderFns } from "./RecordedItems.vue?vue&type=template&id=555653cb&"
import script from "./RecordedItems.vue?vue&type=script&lang=ts&"
export * from "./RecordedItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports